(() => {
  if (window.cardSwatchesBound) return;
  window.cardSwatchesBound = true;

  const absUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('//')) return `${window.location.protocol}${url}`;
    return url;
  };

  const setCardImage = (card, url) => {
    if (!card || !url) return;
    const media = card.querySelector('.card-media');
    if (!media) return;
    const next = absUrl(url);
    if (media.getAttribute('src') === next) return;
    media.removeAttribute('srcset');
    media.removeAttribute('sizes');
    media.src = next;
    card.querySelectorAll('.card__media img:not(.card-media)').forEach((img) => {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = next;
    });
    card.classList.add('card--swatch-active');
  };

  const persistSwatch = (swatch) => {
    const card = swatch.closest('.card-wrapper');
    if (!card) return;
    card.querySelectorAll('.card-swatch').forEach((item) => {
      const selected = item === swatch;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    setCardImage(card, swatch.getAttribute('data-image'));
    const productUrl = swatch.getAttribute('data-url');
    if (productUrl) {
      card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
        link.setAttribute('href', productUrl);
      });
    }
  };

  const previewSwatch = (swatch) => {
    const card = swatch.closest('.card-wrapper');
    if (!card) return;
    setCardImage(card, swatch.getAttribute('data-image'));
  };

  const restoreCard = (card) => {
    const selected = card.querySelector('.card-swatch.is-selected');
    if (selected) setCardImage(card, selected.getAttribute('data-image'));
  };

  const swatchFromPoint = (x, y) => {
    const stack = document.elementsFromPoint(x, y);
    return stack.find((el) => el.classList && el.classList.contains('card-swatch')) || null;
  };

  document.addEventListener(
    'click',
    (event) => {
      const swatch = event.target.closest('.card-swatch');
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
      persistSwatch(swatch);
    },
    true
  );

  document.addEventListener(
    'pointerover',
    (event) => {
      const swatch = event.target.closest('.card-swatch');
      if (!swatch) return;
      previewSwatch(swatch);
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    (event) => {
      const swatch = swatchFromPoint(event.clientX, event.clientY);
      if (swatch) {
        previewSwatch(swatch);
        return;
      }
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerleave',
    (event) => {
      const card = event.target.closest('.card-wrapper');
      if (!card) return;
      if (event.relatedTarget && card.contains(event.relatedTarget)) return;
      restoreCard(card);
    },
    true
  );
})();
